export default "__VITE_ASSET__DSBD4gA7__"